export function formatAvailableCreditAmount(
  value: number | null | undefined,
  formatAmount: (amount: number) => string | undefined
): string {
  if (value == null) return "\u2014";

  return formatAmount(value) ?? "\u2014";
}
